import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

import auth from './auth';
import news from './news';
import profile from './profile';
import watchlist from './watchlist';
import detailStock from './detailStock';
import portfolio from './portfolio';
import stock from './stock';
import stockDiscovery from './stockDiscovery';
import stockIpo from './stockIpo';
import stockHighlight from './stockHighlight';
import mutualFund from './mutualFund';
import search from './search';
import mfDiscovery from './mfDiscovery';
import transaction from './transaction';
import tradeSocket from './tradeSocket';
import mfTransaction from './mfTransaction';
import stockDetailComponent from './stockDetailComponent';
import mfDetailComponent from './mfDetailComponent';
import mfOrder from './mfOrder';
import notification from './notification';
import autoOrder from './autoOrder';
import paymentMethod from './paymentMethod';
import config from './config';
import kycDukcapil from './kycDukcapil';
import pin from './pin';
import referral from './referral';
import compareFund from './compareFund';
import rdn from './rdn';
import freeStock from './freeStock';
import glossary from './glossary';
import simulator from './simulator';
import faq from './faq';
import kycResubmit from './kycResubmit';
import mfwatchlist from './mfwatchlist';
import changeBankAccount from './changeBankAccount';

function rootReducer(history) {
  return combineReducers({
    auth,
    news,
    profile,
    watchlist,
    detailStock,
    portfolio,
    stock,
    stockDiscovery,
    stockIpo,
    stockHighlight,
    mutualFund,
    search,
    mfDiscovery,
    transaction,
    tradeSocket,
    mfTransaction,
    stockDetailComponent,
    mfDetailComponent,
    mfOrder,
    notification,
    autoOrder,
    paymentMethod,
    config,
    kycDukcapil,
    form: formReducer,
    pin,
    referral,
    compareFund,
    rdn,
    freeStock,
    glossary,
    simulator,
    faq,
    kycResubmit,
    mfwatchlist,
    router: connectRouter(history),
    changeBankAccount,
  });
}

export default rootReducer;
